import axios from "axios";
import { API_ROOT } from "config/api-config";

export const WebService = axios.create({
  baseURL: API_ROOT,
  headers: {
    "Content-Type": "application/json",
    "X-Impersonator-Auth-token": localStorage.getItem(
      "impersonator_auth_token"
    ),
  },
});

// WebService.interceptors.response.use(
//   (response) => {
//     // Clean up retry countdown on first successful response
//     cleanupRetryCountdownOnSuccess();
//     return response;
//   },
//   (error) => {
//     const { response } = error;

//     // Show server down page if server is down or not reachable
//     const isServerDown =
//       error.name !== "CanceledError" &&
//       (!response || [0, 502, 503].includes(response?.status));

//     if (isServerDown) {
//       const root = document.getElementById("root");
//       if (root) {
//         ReactDOM.render(<ServerUnavailable />, root);
//         error.handledByInterceptor = true;
//       }
//     }

//     // Automatically refresh the page if the token has expired
//     const isTokenExpired =
//       response?.status === 401 && response?.data?.key === "token_expired";

//     if (isTokenExpired) {
//       window.location.reload();
//     }

//     return Promise.reject(error);
//   }
// );

// Handle token expiration - reload page to force re-authentication
WebService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    const isTokenExpired =
      response?.status === 401 && response?.data?.key === "token_expired";

    if (isTokenExpired) {
      window.location.reload();
    }

    return Promise.reject(error);
  }
);
